// import React, { useEffect, useState } from 'react';
// import { Col, Row, Table } from "reactstrap";
// import { getExceptionFlowSummaryListingService } from '../../../Action';

// const ExceptionFlowSummary = ({ vendorRegId, nsaAuditDetailId, viewDetailReport }) => {
//   const [exceptionSummaryListing, setExceptionFlowSummaryListing] = useState(null);

//   const getExceptionFlowSummary = () => {
//     getExceptionFlowSummaryListingService(vendorRegId, nsaAuditDetailId)
//       .then((res) => {
//         setExceptionFlowSummaryListing(res);
//       })
//       .catch(() => { });
//   };

//   useEffect(() => {
//     getExceptionFlowSummary();
//   }, [vendorRegId, nsaAuditDetailId]);

//   // Function to filter out "Quality", "Total", and "ESG/Sustainability" rows
//   const filteredScores = () => {
//     if (!exceptionSummaryListing) return [];

//     return exceptionSummaryListing.filter(item => (
//       item.checkPointGroupName === "Quality" ||
//       item.checkPointGroupName === "Total" ||
//       item.checkPointGroupName === "ESG/Sustainability"
//     ));
//   };
//   const calculateJudgmentResult = () => {
//     const scores = filteredScores();
//     let qualityScore = 0;
//     let esgScore = 0;
//     let overallScore = 0;

//     scores.forEach((item) => {
//       if (item.checkPointGroupName === 'Quality') {
//         qualityScore = item.auditorPercentage;
//       } else if (item.checkPointGroupName === 'ESG/Sustainability') {
//         esgScore = item.auditorPercentage;
//       } else if (item.checkPointGroupName === 'Total') {
//         overallScore = item.auditorPercentage;
//       }
//     });
//     if (qualityScore >= 60 && esgScore >= 60 && overallScore >= 61) {
//       return <span style={{ color: '#4dc771' }}>Pass</span>
//     } else {
//       return <span style={{ color: '#fc5774' }}>Fail</span>
//     }
//   };
//   return (
//     <Row>
//       <Col md="12">
//         <div className="hl-self-assessment-tbl">
//           <h5 className="text-start mb-1 mt-2"> {viewDetailReport?.data?.auditReportLocation}</h5>
//           <hr className="hr-seprator mb-4" />
//           <Table bordered className="hl-tbl-summary-ttl hl-tbl-assessment-ttl text-start">
//             <tbody>
//               <tr>
//                 <th className="w-30 bg-transparent"></th>
//                 <td className="fw-semibold">Self Assessment Score</td>
//                 <td className="fw-semibold">Requester Score</td>
//                 <td className="fw-semibold">Auditor Score</td>
//               </tr>
//               {exceptionSummaryListing && exceptionSummaryListing.map((item, index) => (
//                 <tr key={index}>
//                   <th className="fw-semibold w-30 bg-transparent">{item.checkPointGroupName}</th>
//                   <td>{item.selfAssessmentScore}</td>
//                   <td>{item.requesterScore}</td>
//                   <td>{item.auditorscore}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//           <Table bordered className="hl-tbl-assessment-ttl table-bordered mt-4 text-start">
//             <thead>
//               <tr>
//                 <th className="fw-semibold">Category</th>
//                 <th className="fw-semibold">Self Assessment Percentage</th>
//                 <th className="fw-semibold">Requester Percentage</th>
//                 <th className="fw-semibold">Auditor Percentage</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredScores().map((item, index) => (
//                 <tr key={index}>
//                   <td>
//                     {item.checkPointGroupName === 'Total'
//                       ? 'Overall Score'
//                       : item.checkPointGroupName === 'Quality'
//                         ? 'Quality Score'
//                         : 'ESG/Sustainability'}
//                   </td>
//                   {/* <td>{item.selfAssessmentPercentage}%</td>
//                   <td>{item.requesterPercentage}%</td>
//                   <td>{item.auditorPercentage}%</td> */}
//                   <td style={{ color: item.selfAssessmentPercentage >= 60 ? '#4dc771' : '#fc5774' }}>
//                     {Math.round(item.selfAssessmentPercentage)}%
//                   </td>
//                   <td style={{ color: item.requesterPercentage >= 60 ? '#4dc771' : '#fc5774' }}>
//                     {Math.round(item.requesterPercentage)}%
//                   </td>
//                   <td style={{ color: item.auditorPercentage > 61 ? '#4dc771' : '#fc5774' }}>
//                     {Math.round(item.auditorPercentage)}%
//                     {/* {item.auditorPercentage}% */}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//           <hr className="hr-seprator" />
//           <div className='hl-judgement-result d-flex flex-column align-items-center'>
//             <h3 className="mt-3 text-start mb-2">
//               Judgement Result: {calculateJudgmentResult()}
//             </h3>
//             <h3 className="mt-2 text-start mb-2">
//               Total NCs Recorded: {exceptionSummaryListing && exceptionSummaryListing.reduce((total, item) => item.nCsRecorded, 0)}
//             </h3>
//           </div>
//         </div>
//       </Col>
//     </Row>
//   );
// }

// export default ExceptionFlowSummary;
import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Spinner } from "reactstrap";
import { getExceptionFlowSummaryListingService } from '../../../Action';
import LoaderCustom from '../../../../../common/LoaderCustom';

const ExceptionFlowSummary = ({ vendorRegId, nsaAuditDetailId, viewDetailReport }) => {
  const [exceptionSummaryListing, setExceptionFlowSummaryListing] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  const getExceptionFlowSummary = () => {
    setLoading(true); // Set loading to true before fetching
    getExceptionFlowSummaryListingService(vendorRegId, nsaAuditDetailId)
      .then((res) => {
        setExceptionFlowSummaryListing(res);
        setLoading(false); // Set loading to false after data is fetched
      })
      .catch(() => {
        setLoading(false); // Also set loading to false on error
      });
  };

  useEffect(() => {
    getExceptionFlowSummary();
  }, [vendorRegId, nsaAuditDetailId]);

  // Function to filter out "Quality", "Total", and "ESG/Sustainability" rows
  const filteredScores = () => {
    if (!exceptionSummaryListing) return [];

    return exceptionSummaryListing.filter(item => (
      item.checkPointGroupName === "Quality" ||
      item.checkPointGroupName === "Total" ||
      item.checkPointGroupName === "ESG/Sustainability"
    ));
  };

  const calculateJudgmentResult = () => {
    const scores = filteredScores();
    let qualityScore = 0;
    let esgScore = 0;
    let overallScore = 0;

    scores.forEach((item) => {
      if (item.checkPointGroupName === 'Quality') {
        qualityScore = Math.round(item.auditorPercentage);
      } else if (item.checkPointGroupName === 'ESG/Sustainability') {
        esgScore = Math.round(item.auditorPercentage);
      } else if (item.checkPointGroupName === 'Total') {
        overallScore = Math.round(item.auditorPercentage);
      }
    });

    if (qualityScore >= 60 && esgScore >= 60 && overallScore >= 61) {
      return <span style={{ color: '#4dc771' }}>Pass</span>;
    } else {
      return <span style={{ color: '#fc5774' }}>Fail</span>;
    }
  };

  if (loading) {
    return (
      <LoaderCustom customClass="simulation-Loader hl-loader-fixed" />
      // <Row>
      //   <Col md="12" className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      //     <Spinner color="primary" />
      //   </Col>
      // </Row>
    );
  }

  return (
    <Row>
      <Col md="12">
        <div className="hl-self-assessment-tbl">
          <h5 className="text-start mb-1 mt-2"> {viewDetailReport?.data?.auditReportLocation}</h5>
          <hr className="hr-seprator mb-4" />
          <Table bordered className="hl-tbl-summary-ttl hl-tbl-assessment-ttl text-start">
            <tbody>
              <tr>
                <th className="w-30 bg-transparent"></th>
                <td className="fw-semibold">Self Assessment Score</td>
                <td className="fw-semibold">Requester Score</td>
                <td className="fw-semibold">Auditor Score</td>
              </tr>
              {exceptionSummaryListing && exceptionSummaryListing.map((item, index) => (
                <tr key={index}>
                  <th className="fw-semibold w-30 bg-transparent">{item.checkPointGroupName}</th>
                  <td>{item.selfAssessmentScore}</td>
                  <td>{item.requesterScore}</td>
                  <td>{item.auditorscore}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Table bordered className="hl-tbl-assessment-ttl table-bordered mt-4 text-start">
            <thead>
              <tr>
                <th className="fw-semibold">Category</th>
                <th className="fw-semibold">Self Assessment Percentage</th>
                <th className="fw-semibold">Requester Percentage</th>
                <th className="fw-semibold">Auditor Percentage</th>
              </tr>
            </thead>
            <tbody>
              {filteredScores().map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.checkPointGroupName === 'Total'
                      ? 'Overall Score'
                      : item.checkPointGroupName === 'Quality'
                        ? 'Quality Score'
                        : 'ESG/Sustainability'}
                  </td>
                  {/* #4dc771 - Green / #fc5774 - Red */}
                  <td style={{ color: Math.round(item?.selfAssessmentPercentage) >= 60 ? '#4dc771' : '#fc5774' }}>
                    {Math.round(item?.selfAssessmentPercentage)}%
                  </td>
                  <td style={{ color: Math.round(item?.requesterPercentage) >= 60 ? '#4dc771' : '#fc5774' }}>
                    {Math.round(item?.requesterPercentage)}%
                  </td>
                  {
                    item.checkPointGroupName === 'Total' ? (
                      <td style={{ color: Math.round(item?.auditorPercentage) >= 61 ? '#4dc771' : '#fc5774' }}>
                        {Math.round(item?.auditorPercentage)}%
                      </td>

                    ) :
                      (
                        <td style={{ color: Math.round(item?.auditorPercentage) >= 60 ? '#4dc771' : '#fc5774' }}>
                          {Math.round(item?.auditorPercentage)}%
                        </td>
                      )

                  }
                </tr>
              ))}
            </tbody>
          </Table>
          <hr className="hr-seprator" />
          <div className='hl-judgement-result d-flex flex-column align-items-center'>
            <h3 className="mt-3 text-start mb-2">
              Judgement Result: {calculateJudgmentResult()}
            </h3>
            <h3 className="mt-2 text-start mb-2">
              Total NCs Recorded: {exceptionSummaryListing && exceptionSummaryListing.reduce((total, item) => item.nCsRecorded, 0)}
            </h3>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default ExceptionFlowSummary;

